export default __webpack_public_path__ + "static/Adjustment-7837f59e3754338f2129e39bd48c2441.png";